import { render, staticRenderFns } from "./ProjectSiteNewFrGroup.vue?vue&type=template&id=499c8f7d&"
import script from "./ProjectSiteNewFrGroup.vue?vue&type=script&lang=js&"
export * from "./ProjectSiteNewFrGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports